import { render } from "./AddSubCategory.vue?vue&type=template&id=49347643&scoped=true"
import script from "./AddSubCategory.vue?vue&type=script&lang=js"
export * from "./AddSubCategory.vue?vue&type=script&lang=js"

import "./AddSubCategory.vue?vue&type=style&index=0&id=49347643&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49347643"]])

export default __exports__